import { Card, CardContent } from "components/ui/card";
import { Skeleton } from "components/ui/skeleton";

interface UsageGraphSkeletonProps {
  isLoading: boolean;
}

export const UsageGraphSkeleton = ({ isLoading }: UsageGraphSkeletonProps) => {
  if (!isLoading) return null;

  return (
    <Card>
      <CardContent className="p-6">
        <Skeleton className="h-[300px] w-full" />
      </CardContent>
    </Card>
  );
};
